import { DialogV2Props } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const dialogOverrides: NonNullable<DialogV2Props['overrides']> = {
  Content: { props: { width: ['100%', pxToRem(540)] } },
};
